module.exports = __webpack_public_path__ + "img/peifer-welding.8b555a7c.jpg";